import { COLUMNS } from '@common/types/columnsEnum';

export enum Providers {
  Spark = 'spark',
  BigQuery = 'BigQuery',
  Databricks = 'Databricks',
  Snowflake = 'Snowflake',
  Trino = 'Trino',
  Redshift = 'Redshift',
  ProphecyManaged = 'ProphecyManaged'
}

export type ProviderType = `${Providers}`;

export type MappingType = { datasetId: string; columnName: string; type: string; datasetName: string };

export type ColumnMetadata = {
  description?: string;
  tags?: { name: string; type: string }[];
  mappings?: MappingType[];
  quote?: boolean;
  hideColumns?: COLUMNS[];
  disableColumns?: COLUMNS[];
  fixedWidthMetadata?: FixedWidthMetadata;
  columnGeneration?: ColumnGeneration;
};

export type FixedWidthMetadata = {
  size?: number;
  scale?: number;
  format?: string;
};

export type ColumnGeneration = {
  type?: 'ALWAYS_AS_IDENTITY' | 'BY_DEFAULT_AS_IDENTITY' | 'ALWAYS_AS';
  alwaysAs?: string;
};

export enum MetaDataFields {
  Description = 'description',
  Tags = 'tags',
  Mappings = 'mappings',
  Quote = 'quote',
  FixedWidthMetadata = 'fixedWidthMetadata',
  ColumnGeneration = 'columnGeneration'
}
